/* ═══════════════════════════════════════
   ZWAGGS — Theme JavaScript
═══════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', function () {

  /* ── MOBILE MENU ── */
  var mobileToggle = document.querySelector('.mobile-toggle');
  var mobileMenu = document.querySelector('.mobile-menu');
  var mmClose = document.querySelector('.mm-close');
  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener('click', function () { mobileMenu.classList.add('open'); document.body.style.overflow = 'hidden'; });
  }
  if (mmClose) {
    mmClose.addEventListener('click', function () { mobileMenu.classList.remove('open'); document.body.style.overflow = ''; });
  }

  /* ── CART DRAWER ── */
  var cartDrawer = document.querySelector('.cart-drawer');
  var cartOverlay = document.querySelector('.cart-overlay');
  var cartTriggers = document.querySelectorAll('[data-cart-toggle]');
  var cartClose = document.querySelector('.cart-close');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('open');
    if (cartOverlay) cartOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    if (cartOverlay) cartOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }
  cartTriggers.forEach(function (t) { t.addEventListener('click', function (e) { e.preventDefault(); openCart(); }); });
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  /* ── ACCORDION ── */
  document.querySelectorAll('.acc-head').forEach(function (head) {
    head.addEventListener('click', function () {
      var body = head.nextElementSibling;
      head.classList.toggle('open');
      if (body) body.classList.toggle('open');
    });
  });

  /* ── QUANTITY SELECTOR ── */
  document.querySelectorAll('.qty-box').forEach(function (box) {
    var input = box.querySelector('.qty-input');
    var minus = box.querySelector('[data-qty-minus]');
    var plus = box.querySelector('[data-qty-plus]');
    if (minus) minus.addEventListener('click', function () {
      var v = parseInt(input.value) || 1;
      if (v > 1) input.value = v - 1;
    });
    if (plus) plus.addEventListener('click', function () {
      var v = parseInt(input.value) || 1;
      input.value = v + 1;
    });
  });

  /* ── PRODUCT GALLERY ── */
  var thumbs = document.querySelectorAll('.pdp-thumb');
  var mainImg = document.querySelector('.pdp-main img');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var src = thumb.getAttribute('data-full') || thumb.querySelector('img').src;
      if (mainImg) mainImg.src = src;
      thumbs.forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
    });
  });

  /* ── VARIANT SELECTION ── */
  var variantForm = document.querySelector('[data-product-form]');
  if (variantForm) {
    var variantData = window.zwaggsVariants || [];
    var selectedOptions = {};

    // initialise from active buttons
    document.querySelectorAll('.opt-values').forEach(function (group) {
      var idx = group.getAttribute('data-option-index');
      var active = group.querySelector('.active');
      if (active) selectedOptions[idx] = active.getAttribute('data-value');
    });

    document.querySelectorAll('[data-option-value]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('.opt-values');
        var idx = group.getAttribute('data-option-index');
        group.querySelectorAll('[data-option-value]').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        selectedOptions[idx] = btn.getAttribute('data-value');

        // update the visible label
        var labelEl = group.parentElement.querySelector('.opt-current');
        if (labelEl) labelEl.textContent = btn.getAttribute('data-value');

        updateVariant();
      });
    });

    function updateVariant() {
      var match = variantData.find(function (v) {
        return Object.keys(selectedOptions).every(function (k) {
          return v.options[parseInt(k)] === selectedOptions[k];
        });
      });
      var idInput = variantForm.querySelector('[name="id"]');
      var priceEl = document.querySelector('[data-price]');
      var atcBtn = variantForm.querySelector('.atc-btn');

      if (match) {
        if (idInput) idInput.value = match.id;
        if (priceEl && match.price) priceEl.innerHTML = match.price;
        if (atcBtn) {
          if (match.available) {
            atcBtn.disabled = false;
            atcBtn.querySelector('span').textContent = 'Add to Cart';
          } else {
            atcBtn.disabled = true;
            atcBtn.querySelector('span').textContent = 'Sold Out';
          }
        }
        // swap featured image if variant has one
        if (match.image && mainImg) mainImg.src = match.image;
      }
    }
  }

  /* ── AJAX ADD TO CART ── */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('.atc-btn');
      var original = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.innerHTML = '<span>Adding…</span>'; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: form.querySelector('[name="id"]').value,
          quantity: parseInt(form.querySelector('[name="quantity"]') ? form.querySelector('[name="quantity"]').value : 1)
        })
      })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (btn) { btn.disabled = false; btn.innerHTML = original; }
        showToast('Added to your cart ✦');
        refreshCart();
        openCart();
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.innerHTML = original; }
        showToast('Something went wrong. Please try again.');
      });
    });
  });

  /* ── QUICK ADD ── */
  document.querySelectorAll('[data-quick-add]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var vid = btn.getAttribute('data-variant-id');
      if (!vid) return;
      btn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: vid, quantity: 1 })
      })
      .then(function (r) { return r.json(); })
      .then(function () {
        btn.textContent = 'Quick Add';
        showToast('Added to your cart ✦');
        refreshCart();
        openCart();
      })
      .catch(function () { btn.textContent = 'Quick Add'; });
    });
  });

  /* ── REFRESH CART ── */
  function refreshCart() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-count').forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
        // reload the drawer contents
        fetch(window.location.pathname + '?section_id=cart-drawer')
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            var newDrawer = doc.querySelector('.cart-drawer');
            var current = document.querySelector('.cart-drawer');
            if (newDrawer && current) {
              var wasOpen = current.classList.contains('open');
              current.innerHTML = newDrawer.innerHTML;
              if (wasOpen) current.classList.add('open');
              bindCartEvents();
            }
          })
          .catch(function () {});
      });
  }

  function bindCartEvents() {
    var c = document.querySelector('.cart-close');
    if (c) c.addEventListener('click', closeCart);
    document.querySelectorAll('[data-cart-remove]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var key = link.getAttribute('data-cart-remove');
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        }).then(function () { refreshCart(); showToast('Item removed'); });
      });
    });
  }
  bindCartEvents();

  /* ── NEWSLETTER ── */
  document.querySelectorAll('.email-form').forEach(function (form) {
    form.addEventListener('submit', function () {
      // let Shopify handle the actual submission
    });
  });

  /* ── TOAST ── */
  window.showToast = function (msg, dur) {
    var toast = document.querySelector('.toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'toast';
      toast.innerHTML = '<span style="color:#c9a84c">✦</span><span class="toast-text"></span>';
      document.body.appendChild(toast);
    }
    toast.querySelector('.toast-text').textContent = msg;
    toast.classList.add('show');
    setTimeout(function () { toast.classList.remove('show'); }, dur || 3000);
  };

  /* ── SCROLL REVEAL ── */
  if ('IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) e.target.classList.add('visible'); });
    }, { threshold: 0.08 });
    document.querySelectorAll('.reveal').forEach(function (el) { obs.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('visible'); });
  }

  /* ── ANNOUNCEMENT MARQUEE DUPLICATE ── */
  var track = document.querySelector('.announce-track');
  if (track && !track.dataset.cloned) {
    track.innerHTML = track.innerHTML + track.innerHTML;
    track.dataset.cloned = 'true';
  }

});
